import type { ColComment } from "../types";
import { MarkupList } from "./MarkupList";
import { useOptionalPostMarkup } from "./PostMarkupProvider";

export function MarkupActivityAttachment({ comment }: { comment: ColComment }) {
  const review = useOptionalPostMarkup();
  const markup = comment.metadata?.markup;
  if (!markup || markup.version !== 1 || comment.type === "DELETED")
    return null;
  return (
    <div className="mt-2" data-testid="markup-activity-attachment">
      <MarkupList
        value={markup}
        collapsible
        resolution={comment.metadata?.markupResolution}
        onSelect={
          review?.enabled
            ? (id) => review.openMarkup(comment._id, id)
            : undefined
        }
        onResolve={
          review?.canWrite
            ? (resolved) => void review.resolve(comment, resolved)
            : undefined
        }
        disabled={review?.isResolving}
      />
    </div>
  );
}
